module.exports = __webpack_public_path__ + "static/media/3522.9bcc5156.jpg";